<template>
	<div class="p-col-12 p-grid">
		<div class="p-col-12 p-lg-6" :class="[commonService.isMobile() ? 'text-box-mobile' : 'text-box']">
			<p>For the Players</p>
			<p class="login-subtitle">Revolutionizing Player Transfers</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">Are you tired of using outdated and unreliable Players transfer services?</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">TiroLibre has got you covered! Our cutting-edge platform utilizes Smart Agents and Smart Contracts to ensure that your transfers are not only safe but transparent too.</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">We believe in providing a seamless experience for our users, which is why we offer dedicated assistance services with a team of experts available 24/7 to guide you through every stage of the transfer process. Say goodbye to the stress and hassle of money transfers, and join the TiroLibre revolution today!</p>
			<p v-if="commonService.isMobile()" class="login-text justified">Looking for a secure and reliable player transfer service?</p>
			<p v-if="commonService.isMobile()" class="login-text justified">Look no further than TiroLibre! Our platform uses cutting-edge Smart Agents and Smart Contracts to guarantee safety and transparency during the transfer process.</p>
			<p v-if="commonService.isMobile()" class="login-text justified">But we don't just stop at security - we provide a seamless user experience with 24/7 support from a team of experts to guide you every step of the way.</p>
			<div v-if="!commonService.isMobile()" :class="isSmallScreen()? 'p-col-6 button-box' : 'p-lg-4 button-box'" style="padding: 0px">
				<Button label="Represent yourself with TiroLibre" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
		<div class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomePlayerTransfersImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
			<div v-if="commonService.isMobile()" class="p-col-10 button-box-mobile" style="margin-top: -30px; margin-bottom: 30px">
				<Button label="Represent yourself with TiroLibre" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
		isSmallScreen() {
			return screen.width <= 1600 ? true : false;
		},
	},
};
</script>

<style scoped>
.justified {
	text-align: justify;
	text-justify: inter-word;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -10px;
	font-size: xx-large;
	font-weight: bold;
}

.login-text {
	margin-top: 10px;
	font-size: 19px;
}

.text-box {
	margin: auto;
	padding-left: 50px;
}

.text-box-mobile {
	margin: auto;
}

.button-box {
	margin-top: 20px;
}

.button-box-mobile {
	margin: auto;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-title {
		margin-top: -15px;
		font-size: 45px;
		font-weight: bold;
	}

	.login-subtitle {
		margin-top: -0px;
		font-size: x-large;
		font-weight: bold;
	}

	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}
}
</style>